import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEO = ({ language, title, description }) => {
  const location = useLocation();
  const baseUrl = window.location.origin;

  useEffect(() => {
    // Update title
    document.title = title;

    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = description;

    // Remove existing hreflang tags
    document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(el => el.remove());

    // Add hreflang tags for all languages
    const languages = [
      { code: 'en', path: '' },
      { code: 'ru', path: '/ru' },
      { code: 'hi', path: '/hi' },
      { code: 'zh', path: '/zh' }
    ];

    // Get current page path without language prefix
    const currentPath = location.pathname.replace(/^\/(ru|hi|zh)/, '');

    languages.forEach(lang => {
      const link = document.createElement('link');
      link.rel = 'alternate';
      link.hreflang = lang.code;
      link.href = `${baseUrl}${lang.path}${currentPath}`;
      document.head.appendChild(link);
    });

    // Add x-default hreflang
    const defaultLink = document.createElement('link');
    defaultLink.rel = 'alternate';
    defaultLink.hreflang = 'x-default';
    defaultLink.href = `${baseUrl}${currentPath}`;
    document.head.appendChild(defaultLink);

    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = `${baseUrl}${location.pathname}`;

    // Update og:locale meta tags
    let ogLocale = document.querySelector('meta[property="og:locale"]');
    if (!ogLocale) {
      ogLocale = document.createElement('meta');
      ogLocale.setAttribute('property', 'og:locale');
      document.head.appendChild(ogLocale);
    }
    const localeMap = { en: 'en_US', ru: 'ru_RU', hi: 'hi_IN', zh: 'zh_CN' };
    ogLocale.content = localeMap[language] || 'en_US';

  }, [language, title, description, location.pathname, baseUrl]);

  return null;
};

export default SEO;
